import SingleColumn from "@/views/SingleColumn.vue";
import User from "@/components/User/index.vue";
import PointsBoard from "@/components/PointsBoard.vue";
import PointsOverview from "@/components/User/PointsOverview.vue";
import Stammdaten from "@/components/User/Stammdaten.vue";
import Index from "@/components/User/Mailbox/Index.vue";
import View from "@/components/User/Mailbox/View.vue";
import Dashboard from "@/components/User/Wholesaler/Dashboard.vue";
import SellerDashboard from "@/components/User/Seller/Dashboard.vue";
import StaffVouchers from "@/components/User/Seller/Voucher/index.vue";
import WholesalerVouchers from "@/components/User/Wholesaler/Voucher/index.vue";
import KpiDashboard from "@/views/KpiDashboard.vue";
import BoosterCcsHistory from "@/views/BoosterCcsHistory.vue";
import { DASHBOARD_SETTINGS } from "@/config";
import { extractCountryCode } from "../utils/tenantUtils";

const url = window.location.href;
const countryCode = extractCountryCode(url);
const useUnifiedDashboard = DASHBOARD_SETTINGS.usesNewKpiDashboard(countryCode);

const dashboardRoutes =
  useUnifiedDashboard
    ? [
        {
          path: "/account/dashboard",
          name: "wholesaler",
          component: SingleColumn,
          props: { content: KpiDashboard },
          meta: {
            requiredRole: [
              "admin",
              "dealer",
              "staff",
              "wholesaler",
              "wholesalerStaff",
              "middleAdmin",
              "lowAdmin",
            ],
          },
        },
        {
          path: "/account/dashboard/booster-ccs",
          name: "boosterCcsHistory",
          component: SingleColumn,
          props: { content: BoosterCcsHistory },
          meta: {
            requiredRole: ["dealer"],
          },
        },
        {
          path: "/staff/dashboard",
          redirect: "/account/dashboard",
          name: "staff",
        },
        {
          path: "/account/points",
          redirect: "/account/dashboard",
          name: "pointsOverview",
        },
      ]
    : [
        {
          path: "/account/points",
          name: "pointsOverview",
          component: SingleColumn,
          props: {
            content: PointsOverview,
          },
          meta: {
            requiredRole: ["dealer"],
            permission: "pointsInfo.see",
          },
        },
        {
          path: "/account/dashboard",
          name: "wholesaler",
          component: SingleColumn,
          props: { content: Dashboard },
          meta: {
            requiredRole: [
              "admin",
              "dealer",
              "staff",
              "wholesaler",
              "wholesalerStaff",
              "middleAdmin",
              "lowAdmin",
            ],
          },
        },
        {
          path: "/staff/dashboard",
          name: "staff",
          component: SingleColumn,
          props: { content: SellerDashboard },
          meta: { requiredRole: ["staff"] },
        },
      ];

export default [
  {
    path: "/account",
    name: "account",
    component: SingleColumn,
    props: {
      content: User,
    },
    meta: {},
  },
  useUnifiedDashboard
    ? {
        path: "/promotions",
        name: "promotions",
        redirect: "/account/dashboard",
      }
    : {
        path: "/promotions",
        name: "promotions",
        component: SingleColumn,
        props: {
          content: PointsBoard,
        },
        meta: {
          requiredRole: ["dealer"],
          //permission: "promotions.see",
        },
      },
  {
    path: "/account/user-profile",
    name: "stammdaten",
    component: SingleColumn,
    props: {
      content: Stammdaten,
    },
    meta: {
      requiredRole: ["dealer"],
      permission: "profilePage.see",
    },
  },
  {
    path: "/account/mailbox",
    name: "mailbox",
    component: SingleColumn,
    props: {
      content: Index,
    },
    meta: {},
  },
  {
    path: "/account/mailbox/:id",
    name: "singleMailbox",
    component: SingleColumn,
    props: {
      content: View,
    },
    meta: {},
  },
  ...dashboardRoutes,
  {
    path: "/staff/vouchers",
    name: "staffVouchers",
    component: SingleColumn,
    props: {
      content: StaffVouchers,
    },
    meta: {
      requiredRole: ["staff"],
    },
  },
  {
    path: "/wholesaler/vouchers",
    name: "wholesalerVouchers",
    component: SingleColumn,
    props: {
      content: WholesalerVouchers,
    },
    meta: {
      requiredRole: ["wholesaler", "wholesalerStaff"],
      requiredLang: ["nl"],
    },
  },
];
